import React, { useState } from 'react';
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getRecords } from "data/Querys";
import { useQuery } from 'react-query';
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";

import Label from "components/general/Label"
import MirsTable from 'components/general/table/Table.js';
import { useMemo } from 'react';
import { ALL_URL, dateFormat } from "helpers/utils"
import SportCode from "components/common/SportCode"
import Competitor from 'components/presentation/Competitor';
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import { NocMemo as Noc } from "components/presentation/Noc";
import { useEventUnit } from "components/common/EventUnit";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import Selector_Event from "components/common/selectors/SelectorEvent";
import SelectorNoc from 'components/common/selectors/selector-noc';
import { Stack } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import useViewport from 'components/general/useViewPort';


const DisciplineRecords = () => {
    const eu = useEventUnit()
    const { mirs_competition, mirs_language, mirs_discipline, mirs_event, mirs_noc, mirs_brokenRecords } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
 

    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, "records")

    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   

    paramsURL["mirs_noc"] = "";

    const getColumnsXl = () => {
        return (
            [
                ColumnEvent({}),
                ColumnRecordType({}),
                ColumnNoc({}),
                ColumnName({}),
                ColumnRecordValue({}),
                ColumnLocation({}),
                ColumnDate({})
            ]
        )
    }

    const getColumnsXs = () => {
        return (
            [
                ColumnEvent({}),
                ColumnRecordType({}),
                ColumnNoc({}),
                ColumnNameLocationDate({}),
                ColumnRecordValue({}),
            ]
        )
    }
    const tableColumns = useMemo(() => isMobile ? getColumnsXs() : getColumnsXl(), [isMobile])
    //DATA
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['recordsByDiscipline', mirs_competition, mirs_language, mirs_discipline],
            queryFn: getRecords,
            //refetchInterval: 5000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data) { return <NotAvailable /> }

    let dataFilter = data?.records
    if (mirs_event && mirs_event !== "all-event") {
        dataFilter = data?.records?.filter(item => item?.record?.event === mirs_event);
    }
    let dataRecords = [];

    if (Array.isArray(dataFilter) && dataFilter.length > 0) {
        dataFilter.forEach(item => {
            item.recordData.forEach(ath => {
                dataRecords.push(
                    {
                        "recordCode": item?.recordCode,
                        "recordOrder": item?.order,
                        "recordType": { ...item?.recordType },
                        "record": { ...item?.record },
                        "athlete": { ...ath }
                    }
                )
            });
        });
    }
    if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
        dataRecords = dataRecords?.filter(item => item?.athlete?.competitor?.organisation?.code === mirs_noc);
    }

    if (mirs_brokenRecords && mirs_brokenRecords === 'true') {
        dataRecords = dataRecords?.filter(item => item?.athlete?.historic === false);
    }

    const handleOnChange = (e) => {

        paramsURL["mirs_brokenRecords"] = e.target.checked ? true : false
        paramsURL["mirs_noc"] = ALL_URL.ALL_NOC
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };
    let sw = mirs_brokenRecords === 'true' ? true : false
    return (<>
        <Stack direction={isMobile ? 'vertical' : 'horizontal'}>
            <SelectorDiscipline display_type="combo" page="records" />
            <Selector_Event  page="records" />
            <SelectorNoc display_type="combo" page="records" />
            <Form.Check checked={sw} label={<Label data='LabelOnlyBrokenRecords' />} name="brokenRecord" type="checkbox" onChange={(e) => handleOnChange(e)} />
        </Stack>
        {dataRecords && <MirsTable
            id={`mirs-table-records`}
            data={dataRecords}
            columns={tableColumns}
            showLoading={false}
            initialSortBy={[{ id: 'Event', desc: false }, { id: 'RecordName', desc: false }]}
        />}


    </>);
};


export function ColumnEvent({
    disableSort = true,
    label = "HeaderEvent",
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'record.order',
            headerClassName: 'text-start w-25',
            id: 'Event',
            Cell: (props) => {
                const eu = useEventUnit()
                const row = props.cell.row.original
                return (
                    <div className='text-wrap'>{eu(row?.recordCode, false)}</div>
                  
                )
            }
        }
    )
}

function ColumnRecordType({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-5',
    label = 'HeaderType',
    headerRecord = undefined,
}) {
    return (
        {
            Header: (props) => {
                let labelCode = headerRecord ? headerRecord : <><Label data={label} /></>;
                return (labelCode)
            },
            accessor: 'recordOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'RecordName',
            Cell: (props) => (
                <abbr title={props.cell.row.original.recordType.description}>{props.cell.row.original.recordType.code.substring(3)}</abbr>
            )
        }
    )
}


export function ColumnNoc({

    disableSort = true,
    className = 'text-start d-none d-md-table-cell ',
    headerClassName = 'text-start d-none d-md-table-cell w-5',
    label = 'HeaderNOC',
    remove = false
}) {

    const competition = CompetitionFromStore();
    if (isParalympic(competition) && label === 'HeaderNOC') {
        label = 'HeaderNPC';
    }

    return (
        {
            Header: "",
            id: 'NOC',
            accessor: 'participant.organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                let data = row?.athlete?.competitor?.organisation
                const current = row?.athlete?.current;
                const historic = row?.athlete?.historic;

                let out;
                if (current && !historic) {
                    out = <><div className='d-flex align-items-end'><span className='newRecord'><Label data={'LabelNew'} /></span> <Noc {...data} /></div></>
                } else {
                    out = <Noc {...data} />
                }
                return (out)
            }
        }
    )

}

function ColumnName({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-15',
    label = '-',
    hideNoc = false,
}) {

    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== '-') {
                    lbl = label
                } else {
                    lbl = row?.record?.event?.includes('K4') ? 'HeaderTeam' : 'HeaderName'
                }

                return (
                    <Label data={lbl} />
                )
            },
            accessor: 'athlete.competitor.code',
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                return getName(props.cell.row.original, mirs_discipline, hideNoc);
            }
        }
    )
}


function ColumnRecordValue({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = "",
    resultType = "",
    forceResultTypeHader = undefined
}) {
    return (
        {
            Header: (props) => {
                const resultType = props?.data[0]?.recordDataFiltered?.resultType;
                let labelCode = resultType === 'DISTANCE' ? 'HeaderDistance' : resultType === 'POINTS' ? 'HeaderPoints' : resultType === 'TIME' ? 'HeaderTime' : 'HeaderMark';
                labelCode = forceResultTypeHader ? forceResultTypeHader : labelCode;
                return (<Label data={labelCode} />)
            },
            accessor: 'athlete.result',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'RecordValue',
        }
    )
}

function ColumnLocation({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-15',
    label = 'HeaderLocation',
    accessor = 'athlete.place'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Location'
        }
    )
}


function ColumnDate({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = 'HeaderDate',
    accessor = 'athlete.recordDate'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Date',
            Cell: props => getDate(props.cell.row.original)
        }
    )
}



function ColumnNameLocationDate({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-15',
    label = 'HeaderName',
    hideNoc = false,
    accessor =  'athlete.competitor.code',

}) {
    return (
        {
            Header: <><Label data={'HeaderName'} /> / <Label data={'HeaderLocation'} /></>,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'NameLocationDate',
            accessor: accessor,
            Cell: (props) => {
                const row =  props.cell.row.original;
                const { mirs_discipline } = useUrlFriendlyToParameters()
                const current = row?.athlete?.current;
                const historic = row?.athlete?.historic;
                const newBrokenRecord = (current && !historic) && <div className='d-flex align-items-end'><span className='newRecord'><Label data={'LabelNew'} /></span></div>
                return (
                    <Stack direction="vertical">
                        <Stack direction="horizontal">
                            {newBrokenRecord}&nbsp;{getName(row, mirs_discipline, hideNoc)}
                        </Stack>
                        <Stack direction="horizontal">
                            {getDate(row)}&nbsp;&nbsp;{row?.athlete.place}
                        </Stack>
                    </Stack>
                )
            }
        }
    )
}

export default DisciplineRecords;

const getDate = row => {
    return row?.athlete?.recordDate && dateFormat(row?.athlete?.recordDate, "", "MMM D, YYYY")
}

const getName = (row, discipline, hideNoc) => {

    const historic = row?.athlete?.historic;

    let noLink = false;

    if (!row?.athlete?.competitor) {
        return ''
    }
    let name;
    let shortName;
    let athlete;
    let athleteName;
    let athleteShortName;

    if (row?.athlete?.competitor?.athletes && Array.isArray(row?.athlete?.competitor?.athletes) && row?.athlete?.competitor?.athletes.length > 0) {
        athlete = row?.athlete?.competitor?.athletes[0];                    
        athleteName = `${athlete?.familyName?.toUpperCase()} ${(athlete?.givenName) ? athlete?.givenName:''}`;
        athleteShortName = `${athlete?.familyName?.toUpperCase()} ${(athlete?.givenName) ? athlete?.givenName?.slice(0, 1) : ''}`;
    }

    if (row?.athlete?.competitor?.participant) {
        name = row?.athlete?.competitor?.participant?.name;
        shortName = row?.athlete?.competitor?.participant?.shortName;

        name = name ? name : athleteName ? athleteName : '';
        shortName = shortName ? shortName : athleteShortName ? athleteShortName : '';

        row.athlete.competitor.participant.name = name;
        row.athlete.competitor.participant.shortName = shortName;

    } else if (athleteName) {
        row.athlete.competitor.participant = { name: athleteName, shortName: athleteShortName };
        row.athlete.competitor.participant.organisation = row?.athlete?.competitor?.organisation
    }

    let data = row?.athlete?.competitor?.participant

    noLink = historic ? true : row?.athlete?.competitor?.participant?.code === undefined ? true : false

    let out;
    if (name) {
        out = <Competitor {...data} hidePicture={true} hideNoc={hideNoc} noLink={noLink} />
    } else if (row?.notEstablished) {
        out = <SportCode code={row?.notEstablishedLabel} discipline={discipline} entity="@NoRecord" />
    } else { out = '' }

    return (
        out
    )

}

